import { formatPlaybookDisplayTitle } from "@/lib/playbook-utils";
import { cn } from "@/lib/utils";

type PlaybookTitleProps = {
  title: string;
  variant?: "card" | "preview";
  className?: string;
};

const clampStyles = "line-clamp-2 overflow-hidden break-words [overflow-wrap:anywhere]";

export function PlaybookTitle({ title, variant = "card", className }: PlaybookTitleProps) {
  const displayTitle = formatPlaybookDisplayTitle(title);
  const Tag = variant === "preview" ? "h2" : "h3";

  return (
    <Tag
      className={cn(
        "font-medium text-foreground",
        clampStyles,
        variant === "preview"
          ? "font-display text-xl leading-snug"
          : "font-sans text-base leading-6 tracking-[-0.015em]",
        className,
      )}
      title={displayTitle}
    >
      {displayTitle}
    </Tag>
  );
}
